import { Button, DataSource, Layout, Panel, SearchButton, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSearchDriverCallinHistory extends Layout {
    buttonClear: Button;
    panelSearch: Panel;
    panelSearchButtons: Panel;
    searchbuttonSearch: SearchButton;
    sourceDriverCallinHistory: DataSource;
    tabTabSearch: Tab;
    tableDriverCallinHistory: Table;
    tabsetSearchFilter: Tabset;
    textboxCallinTime: Textbox;
    textboxDriver: Textbox;
    textboxOrder: Textbox;
    textboxSearchCallinStatus: Textbox;
    textboxSearchEnteredBy: Textbox;
    textboxTractor: Textbox;
}
